import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import { deepEqual } from '../utils';
export var AVERAGE_DESKTOP_WIDTH = 1300;

function debounce(fn) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var timeout;
  return function () {
    var _this = this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    clearTimeout(timeout);
    timeout = setTimeout(function () {
      return fn.call.apply(fn, [_this].concat(args));
    }, wait);
  };
}

var Breakpoint = /*#__PURE__*/function (_React$Component) {
  _inherits(Breakpoint, _React$Component);

  var _super = _createSuper(Breakpoint);

  function Breakpoint(props) {
    var _this2;

    _classCallCheck(this, Breakpoint);

    _this2 = _super.call(this, props);
    _this2.previousBreakpoint = /*#__PURE__*/React.createRef(null);
    _this2.onResize = debounce(_this2.onResize.bind(_assertThisInitialized(_this2)), 50);
    _this2.state = {
      ssr: props.ssr,
      width: typeof window === 'undefined' || props.ssr ? props.defaultWidth : window.innerWidth
    };
    return _this2;
  }

  _createClass(Breakpoint, [{
    key: "onResize",
    value: function onResize() {
      this.setState(function () {
        return {
          width: window.innerWidth
        };
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.resizeHandler = window.addEventListener('resize', this.onResize);
      this.setState(function () {
        return {
          ssr: false,
          width: window.innerWidth
        };
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.onResize);
    }
  }, {
    key: "getBpOptions",
    value: function getBpOptions() {
      var aliases = ['sm', 'md', 'lg', 'xl'];
      var options = [];

      for (var _i = 0, _aliases = aliases; _i < _aliases.length; _i++) {
        var alias = _aliases[_i];
        options.push(alias);

        if (this.state.width <= (this.props.theme.breakpoints[alias] || 0)) {
          break;
        }
      }

      return options.reverse();
    }
  }, {
    key: "getCurrentBp",
    value: function getCurrentBp() {
      return this.getBpOptions()[0];
    }
  }, {
    key: "render",
    value: function render() {
      var breakpoint = {
        width: this.state.width,
        bpOptions: this.getBpOptions(),
        bpName: this.getCurrentBp()
      };

      if (deepEqual(breakpoint, this.previousBreakpoint.current)) {
        return this.props.children(this.previousBreakpoint.current);
      } else {
        this.previousBreakpoint.current = breakpoint;
        return this.props.children(breakpoint);
      }
    }
  }]);

  return Breakpoint;
}(React.Component);

process.env.NODE_ENV !== "production" ? Breakpoint.propTypes = {
  children: PropTypes.func.isRequired,
  defaultWidth: PropTypes.number.isRequired
} : void 0;
Breakpoint.defaultProps = {
  children: function children() {},
  defaultWidth: AVERAGE_DESKTOP_WIDTH,
  ssr: false
};
export default withTheme(Breakpoint);